import React from "react";

const PAW_PATH = "M212,80a28,28,0,1,0,28,28A28,28,0,0,0,212,80Zm0,40a12,12,0,1,1,12-12A12,12,0,0,1,212,120ZM72,108a28,28,0,1,0-28,28A28,28,0,0,0,72,108ZM44,120a12,12,0,1,1,12-12A12,12,0,0,1,44,120ZM92,88A28,28,0,1,0,64,60,28,28,0,0,0,92,88Zm0-40A12,12,0,1,1,80,60,12,12,0,0,1,92,48Zm72,40a28,28,0,1,0-28-28A28,28,0,0,0,164,88Zm0-40a12,12,0,1,1-12,12A12,12,0,0,1,164,48Zm23.12,100.86a35.3,35.3,0,0,1-16.87-21.14,44,44,0,0,0-84.5,0A35.25,35.25,0,0,1,69,148.82,40,40,0,0,0,88,224a39.48,39.48,0,0,0,15.52-3.13,64.09,64.09,0,0,1,48.87,0,40,40,0,0,0,34.73-72ZM168,208a24,24,0,0,1-9.45-1.93,80.14,80.14,0,0,0-61.19,0,24,24,0,0,1-20.71-43.26,51.22,51.22,0,0,0,24.46-30.67,28,28,0,0,1,53.78,0,51.27,27.27,0,0,0,24.53,30.71A24,24,0,0,1,168,208Z";

export default function PetMapPinIcon({ className, color = "#ffffff", active = false }) {
    // Original SVG viewbox is 0 0 48 48
    // We render it as a responsive component.
    // Logic adapted from makePetPinIcon in PetReportsMapPage.

    // Scale paw to fit in the pin circle (roughly 50% scale relative to original 256x256 paw path)
    // The original code used a complex transform based on 48x48.
    // Paw Path is defined on a 256x256 grid.
    // Center of pin is 24, 18.
    // Target radius ~10.
    // We can just use a group transform.

    return (
        <svg viewBox="0 0 48 48" className={className} xmlns="http://www.w3.org/2000/svg">
            {/* Pin Body */}
            <path
                d="M24 2C15.163 2 8 9.163 8 18c0 11.6 16 28 16 28s16-16.4 16-28C40 9.163 32.837 2 24 2z"
                fill={color}
            />

            {/* Active Stroke (Optional) */}
            {active && (
                <path
                    d="M24 2C15.163 2 8 9.163 8 18c0 11.6 16 28 16 28s16-16.4 16-28C40 9.163 32.837 2 24 2z"
                    fill="none" stroke="white" strokeWidth="2.2" opacity="0.95"
                />
            )}

            {/* Inner White Circle */}
            <circle cx="24" cy="18" r="10.2" fill="white" opacity="0.95" />

            {/* Paw Icon */}
            {/* 
                Original transform: translate(cx - 128*scale, cy - 128*scale) scale(scale)
                scale = 16/256 = 0.0625.
                cx=24, cy=18.
                dx = 24 - 128*0.0625 = 24 - 8 = 16
                dy = 18 - 8 = 10
            */}
            <g transform="translate(16, 10) scale(0.0625)">
                <path d={PAW_PATH} fill={color} />
            </g>
        </svg>
    );
}
